import { SET_ERROR, CLEAR_ERROR } from "../../constants/actionTypes";

export const setErrors = (errors) => {
  return {
    type: SET_ERROR,
    payload: errors,
  };
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERROR,
    payload: {},
  };
};
